import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error png import
import DataStudioHero from 'bender-url!./images/DataStudioHero.png';
import { Flex } from 'foundations-components/components/Flex';
import { Image } from 'foundations-components/transitional/components/Image';
import { Link } from 'foundations-components/transitional/components/Link';
import SolutionCardLayoutUI from './SolutionCardLayoutUI';
import DataAgentIcon from './images/icons/DataAgentIcon';
import DataStudioIcon from './images/icons/DataStudioIcon';
import JourneyReportingIcon from './images/icons/JourneyReportingIcon';
import SegmentsIcon from './images/icons/SegmentsIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DataStudioCard = () => {
  return /*#__PURE__*/_jsx(SolutionCardLayoutUI, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.hsoc.solutionCards.dataStudio.title"
    }),
    subheading: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("span", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.hsoc.solutionCards.dataStudio.subheading"
        })
      }), ' ', /*#__PURE__*/_jsx("span", {
        children: /*#__PURE__*/_jsx(Link, {
          underline: true,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "pricing-pages-ui.hsoc.solutionCards.learnMore"
          })
        })
      })]
    }),
    features: [{
      icon: /*#__PURE__*/_jsx(DataAgentIcon, {}),
      name: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-pages-ui.hsoc.solutionCards.features.dataAgent.name"
      }),
      description: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-pages-ui.hsoc.solutionCards.features.dataAgent.description"
      })
    }, {
      icon: /*#__PURE__*/_jsx(JourneyReportingIcon, {}),
      name: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-pages-ui.hsoc.solutionCards.features.journeyReporting.name"
      }),
      description: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-pages-ui.hsoc.solutionCards.features.journeyReporting.description"
      })
    }, {
      icon: /*#__PURE__*/_jsx(SegmentsIcon, {}),
      name: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-pages-ui.hsoc.solutionCards.features.segments.name"
      }),
      description: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-pages-ui.hsoc.solutionCards.features.segments.description"
      })
    }, {
      icon: /*#__PURE__*/_jsx(DataStudioIcon, {}),
      name: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-pages-ui.hsoc.solutionCards.features.dataStudio.name"
      }),
      description: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-pages-ui.hsoc.solutionCards.features.dataStudio.description"
      })
    }],
    image: /*#__PURE__*/_jsx(Flex, {
      inlineSize: "100%",
      blockSize: "100%",
      justifyContent: "end",
      alignItems: "end",
      backgroundColor: "fill-caution-default",
      paddingInlineStart: "800",
      paddingBlockStart: "1400",
      children: /*#__PURE__*/_jsx(Image, {
        src: DataStudioHero,
        zIndex: 1
      })
    }),
    footer: /*#__PURE__*/_jsx(Link, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-pages-ui.hsoc.solutionCards.seeRateSheet"
      })
    })
  });
};
export default DataStudioCard;